import { useContext } from "react";
import { ISessionStateContext, SessionStateContext } from "../../../../Core/State/SessionStateContext";
import { IButtonStyles, IconButton, mergeStyleSets, Modal, ResponsiveMode, Stack, Text } from "@fluentui/react";
import { PartnerBookinAvailabilityList } from "../../../Partner/PartnerBookinAvailabilityList/PartnerBookinAvailabilityList";
import { BookingSource } from "../../../../Model/PartnerModels";
import { t } from "i18next";


export interface ICustomerBookingModalProps {
    showModal:boolean;
    onDismiss: () => void;
}

export const CustomerBookingModal : React.FC<ICustomerBookingModalProps> = (props) => {
    const sessionInfoContext = useContext<ISessionStateContext>(SessionStateContext);

    const ContentStyles = mergeStyleSets({
        Container: {
            width: "78%",
            marginTop: '10px',
            paddingLeft: '1em',
            paddingBottom: '1em',
            paddingRight: '1em',
            paddingTop: '1em',
            transition: 'width 0.01s linear',
            zIndex: 10,
        },
        Body: {
            padding: '0 10px 10px 10px',
            overflowY: 'hidden',
            selectors: {
                p: { margin: '14px 0' },
                'p:first-child': { marginTop: 0 },
                'p:last-child': { marginBottom: 0 },
            }
        }
    });

    const iconButtonStyles: Partial<IButtonStyles> = {
        root: {
            color: "black",
            marginLeft: 'auto',
            marginRight: '2px',
        },
        rootHovered: {
            color: "gray",
        }
    };

    return(
        <Modal
            titleAriaId={"BookingModal"}
            isOpen={props.showModal}
            onDismiss={props.onDismiss}
            containerClassName={ContentStyles.Container}
            dragOptions={undefined}
            styles={{
                main:{ 
                    width: '79% !important',
                    maxWidth: 'calc(79%) !important',
                    maxHeight: 'calc(100vh - 80px)',
                    borderRadius: 10
                },
                scrollableContent:{
                    overflowY: 'hidden'
                },
            }}
        >
            <Stack horizontal horizontalAlign="space-between">
                <Stack.Item>
                    <Text variant="xLarge">{t("demoRoleCenter:bookingModal:title")!}</Text>
                </Stack.Item>
                <Stack.Item>
                    <IconButton
                        styles={iconButtonStyles}
                        iconProps={{ iconName: 'Cancel' }}
                        ariaLabel="Close popup modal"
                        onClick={props.onDismiss}
                    />
                </Stack.Item>
            </Stack>
            <PartnerBookinAvailabilityList
                mode="lead"
                leadId={sessionInfoContext.currentUser.leadId}
                leadName={""}
                key={"BookingListModal"}
                source={BookingSource.Demo}
                isModal
            />
        </Modal>
    )
}